import { ROUTES } from '../routeNames'

export const resolveRequiredPermissionRedirect = (
  requiredPermission: unknown,
  canAccess: (permission: string) => boolean,
  teamPid: string | string[] | undefined
) => {
  if (typeof requiredPermission !== 'string' || canAccess(requiredPermission)) {
    return null
  }

  const normalizedTeamPid = Array.isArray(teamPid) ? teamPid[0] : teamPid

  return {
    name: ROUTES.DASHBOARD,
    ...(normalizedTeamPid ? { params: { teamPid: normalizedTeamPid } } : {})
  }
}
